var chunkMapping = {
	"346": [
		40346
	],
	"2672": [
		72672
	],
	"3262": [
		53262
	],
	"3785": [
		93785
	],
	"6375": [
		6375
	],
	"7327": [
		67327
	],
	"7873": [
		77873
	],
	"9541": [
		49541
	]
};
var idToExternalAndNameMapping = {
	"6375": [
		"default",
		"./SearchResultNoArticle",
		78460
	],
	"40346": [
		"default",
		"./ArticleBannerCard",
		72103
	],
	"49541": [
		"default",
		"./SideCaddy",
		6929
	],
	"53262": [
		"default",
		"./CartState",
		6929
	],
	"67327": [
		"default",
		"./GlobalHeader",
		78460
	],
	"72672": [
		"default",
		"./SearchResultArticle",
		78460
	],
	"77873": [
		"default",
		"./MetroLogo",
		78460
	],
	"93785": [
		"default",
		"./UidispatcherApiModule",
		56190
	]
};
var idToRemoteMap = {
	"6375": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"40346": [
		{
			"externalType": "script",
			"name": "cia_explore_ui",
			"externalModuleId": 72103
		}
	],
	"49541": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"53262": [
		{
			"externalType": "script",
			"name": "oc_ui",
			"externalModuleId": 6929
		}
	],
	"67327": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"72672": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"77873": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui",
			"externalModuleId": 78460
		}
	],
	"93785": [
		{
			"externalType": "script",
			"name": "uidispatcher_api",
			"externalModuleId": 56190
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}